/**
 * @file 会员订阅弹窗常量配置
 */
// import { MemberTier, BillingCycle } from './types';

export const GoodValueImgUrl =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/commerce/9187dfb2f81bfed61f1d334a8.png';

export const PaySuccessImgUrl =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/commerce/paysuccess.png';
